import React from 'react';
import { NavLink } from 'react-router-dom';
import { Label } from 'sdc-i18n-react';
import { VisibleNotAuthenticated } from '../../helpers';
import './button.scss';

var TheLoginButton = function TheLoginButton(_ref) {
  var url = _ref.url;
  return /*#__PURE__*/React.createElement(NavLink, {
    className: "nav-link login-button",
    to: url
  }, /*#__PURE__*/React.createElement(Label, {
    value: "action.login"
  }));
};

export var LoginButton = VisibleNotAuthenticated(TheLoginButton);